export default "__VITE_ASSET__6947c160__"